<template>
  <div class="project">
      <card-m
        title="项目主页"
        cardWidth="100%"
        cardHeight="100%"
        maxHeight="unset"
        :show-filter="true"
        :show-export="true"
        :show-column-edit="true"
        export-file-name="项目列表"
        @export="handleExport"
        @edit-column="openColumnEdit"
      >
        <!-- 统计范围下拉框 -->
        <template slot="card-tool">
          <div class="statistic-range-selector">
            <span class="selector-label">统计范围：</span>
            <el-select
              v-model="statisticRange"
              placeholder="请选择"
              size="mini"
              @change="handleStatisticRange"
            >
              <el-option label="本年" value="year"></el-option>
              <el-option label="本月" value="month"></el-option>
            </el-select>
          </div>
        </template>

        <!-- 使用封装的 SummaryCards 组件 -->
        <template slot="card-box1">
          <div v-loading="cardLoading" style="min-height: 100px;">
            <summary-cards
              :card-data="cardData"
              :statistic-range="statisticRange"
            />
          </div>
        </template>

        <template slot="card-box">
          <!-- 当 showTableView 为 true 时，显示表格 -->
          <!-- <div v-if="showTableView" >  -->
          <div v-if="showTableView" style="height: 100%;"> 
            <!-- @switchChange="handleSwitchChange" 监听开关变化事件 -->  
            <!-- @linkClick="handleLinkClick"  监听通用链接点击事件  -->
            <!-- @projectLinkClick="goToInfo"  监听项目名称链接特定事件           -->
            <!--  @textEditClick="handleTextEditClick"监听文字编辑点击事件 -->
            <!--@dateEditClick="handleDateEdit"   监听日期编辑点击 -->

          <card-table
            tableID="projectTable"
            :tableColumn="effectiveVisibleColumns"
            :tableData="projectData"
            :total="projectTotal"
            :showIndex="true"
            :key="tableRenderKey"
            :mobileColumns="mobileColumnEditFilter"
            :loading="loading"
            @projectLinkClick="goToInfo"
            @column-width-change="onColumnWidthChange"
            style="height: 100%;"
            :pageSizes="[50, 100, 200, 300, 400, 500]"
            :size="currentProjectListPageSize" 
            :currentPage="currentProjectListPage"
            @currentChange="handleProjectCurrentChanges"
            @sizeChange="handleProjectSizeChanges"

            @column-filter-change="onColumnFilterChange" 
            :columnFilterValues="columnFilterValues"
            @icon-click="handleStatusIconClick"
          ></card-table>          

          </div>

          <!-- 当 showTableView 为 false 时，显示图片 -->
        <div v-else class="image-view-placeholder" style="height: 100%;" v-loading="loading">
          <project-cards
            :card-data="projectData"
            :total="projectTotal"
            :current-page="currentProjectCardsPage"  
            :page-size="currentProjectCardsPageSize" 
            :page-sizes="[6, 12, 18, 24]"
            :show-paging="true"
            :key="cardsRenderKey"
            @sizeChange="handleCardsSizeChanges"  
            @currentChange="handleCardsCurrentChanges" 
            @cardClick="handleCardClick"
            @projectLinkClick="goToInfo"
          />
        </div>
        </template>

        <!-- 筛选框插槽内容：手机端始终显示，电脑端只在卡片模式显示 -->
        <template slot="card-filter">
          <div class="filter-content">
            <!-- <div class="filter-item" v-if="isMobile || !showTableView">
              <el-input
                placeholder="项目编号"
                clearable
                size="mini"
                v-model="columnFilterValues['项目编号']"
                suffix-icon="el-icon-search"
                @change="onCardFilterChange"
              >
              </el-input>
            </div>

            <div class="filter-item" v-if="isMobile || !showTableView">
              <el-input
                placeholder="项目名称"
                clearable
                size="mini"
                v-model="columnFilterValues['项目名称']"
                suffix-icon="el-icon-search"
                @change="onCardFilterChange"
              >
              </el-input>
            </div>

            <div class="filter-item" v-if="isMobile || !showTableView">
              <el-input
                size="mini"
                v-model="columnFilterValues['业务员']"
                @change="onCardFilterChange"
                clearable
                placeholder="业务员"
                suffix-icon="el-icon-search"
              >
              </el-input>
            </div>

            <div class="filter-item" v-if="isMobile || !showTableView">
              <el-select
                size="mini"
                v-model="columnFilterValues['项目阶段']"
                filterable
                @change="onCardFilterChange"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in projectStatusList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
                ></el-option>
              </el-select>
            </div> -->

            <!-- 【新增】: 在最右侧添加视图切换开关 -->
            <div class="filter-item view-toggle">
              <el-switch
                v-model="showTableView"
                active-text="表格"
                inactive-text="卡片"
                active-color="#2564CFCC"
                inactive-color="#2564CFCC"
                @change="handleViewToggle"
              >
              </el-switch>
            </div>

          </div>
        </template>
      </card-m>

    <!-- 列编辑弹窗 -->
    <column-edit-dialog
      :visible.sync="columnEditVisible"
      :columns="tempOrderedColumns"
      :defaultColumns="effectiveDefaultColumnDefs"
      :title="columnEditTitle"
      :dialogWidth="columnEditDialogWidth"
      @confirm="handleColumnSave"
      @cancel="handleColumnCancel"
    />

    <!-- 项目异常详情弹窗：点击状态列红色圆点弹出 -->
    <common-dialog-table
      :visible="exceptionDialogVisible"
      :title="'项目异常详情 - 项目编号: ' + currentExceptionProjectNo"
      :tableColumn="exceptionListColumn"
      :tableData="exceptionList"
      @close="closeExceptionDialog"
    />
    </div>
</template>

<script>
// import axios from 'axios';
import { convertDateFormat } from '@/utils/tools.js';
import { getProjectHomeList, getProjectHomeList1, getSummaryData, getAbnormalInfo} from '@/api/mainapi.js';
import columnEditMixin from '@/mixins/columnEditMixin';
import ColumnEditDialog from '@/components/ColumnEditDialog.vue';
import CommonDialogTable from '@/components/card/CommonDialogTable.vue';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
// import { getDataList, getContractIdList, getSummaryData} from '@/api/mainapi.js';
// import { projectCardApi } from '@/mock/projectCard.js';

// 导入封装的组件
import SummaryCards from './SummaryCards.vue';
import ProjectCards from './ProjectsCards.vue';  // 新增导入

/* ✅ 项目阶段：下拉筛选 / 表头筛选共用同一份选项（顺序即下拉框显示顺序） */
const PROJECT_STAGE_OPTIONS = [
  { value: '', label: '全部' },
  { value: '中标', label: '中标' },
  { value: '投标中', label: '投标中' },
  { value: '未中标', label: '未中标' },
  { value: '投标准备', label: '投标准备' },
  { value: '信息收集', label: '信息收集' },
  { value: '跟进', label: '跟进' },
  { value: '线索收集', label: '线索收集' },
  { value: '其他', label: '其他' },
  { value: '中止', label: '中止' },
];

/* ✅ 项目阶段 → 状态圆点颜色（数字对应 card-table 里 getStatusCircleClass 的映射）
   0 红 / 1 绿 / 2 蓝 / 3 橙 / 4 灰 */
const STAGE_STATUS_CODE = {
  投标准备: 4,
  信息收集: 4,
  跟进: 4,
  线索收集: 4,
  其他: 4,
  投标中: 2,
  中标: 1,
  中止: 3,
  未中标: 3
};
const STATUS_CODE_EXCEPTION = 0;   // 有异常 → 红色，优先级最高
const STATUS_CODE_DEFAULT = 4;     // 未知阶段 → 灰色

export default {
  name: 'home',
  mixins: [columnEditMixin],
  props: {
    msg: String
  },
  components: {
    SummaryCards,
    ProjectCards,
    ColumnEditDialog,
    CommonDialogTable
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
    baseColumnDefs() {
      return this.projectListColumn;
    }
  },
  data() {
    return {
      pageType: 'projectProgress',
      loading: false,
      cardLoading: false,

      statisticRange: 'month',
      cardData: {
        project: {
          title: '项目',
          value1: null,
          value2: null,
          label1: '已投标',
          label2: '项目总数',
          tableData: { bidding: [] }
        },
        contract: {
          title: '合同',
          value1: null,
          value2: null,
          unReviewCount: null,
          label1: '未审核金额',
          label2: '累计金额',
          label3: '未审核数量'
        },
        execute: {
          title: '执行',
          value1: null,
          value2: null,
          label1: '异常执行合同数',
          label2: '执行中合同数'
        },
        shipment: {
          title: '发运',
          value1: null,
          value2: null,
          label1: '异常发运合同数',
          label2: '发运合同总数'
        },
        afterSales: {
          title: '售后',
          value1: null,
          value2: null,
          label1: '未完成售后数',
          label2: '售后总数'
        },
        receivable: {
          title: '应收',
          value1: null,
          externalAccount: null,
          internalAccount: null,
          label1: '应收金额',
          label2: '网点外部账款',
          label3: '自签内部账款'
        }
      },

      projectData: [],
      projectTotal: 0,
      
      // 视图切换
      showTableView: true, // true 显示表格，false 显示图片
      
      // ==================筛选===========================================
      projectSearchKeyword: '',
      projectSearchType: [
        { value: '项目号', label: '项目号' },
        { value: '项目名称', label: '项目名称'}
      ],
      projectSearchTypeValue: '项目号', //搜索框对应的类型值【项目列表

      projectStatus: '',
      // ✅ 项目阶段下拉选项：全部 / 投标准备 / 信息收集 / 跟进 / 线索收集 / 其他 / 投标中 / 中标 / 中止 / 未中标
      projectStatusList: PROJECT_STAGE_OPTIONS,

      currentProjectSalesRepName: '', //人员编号
      currentProjectKeyword: '', //当前查询关键字 【项目列表
      currentProjectNo:'', 
      currentProjectContractNo: '', //当前查询项目的合同编号【项目列表
      currentProjectState: '', //当前查询项目状态【项目列表

      // 筛选更新时间范围数据
    timeRangeType: 'all',
    showCustomPicker: false,
    updateTimeRange: [],


      currentUpdateTimeStart: '', // 当前查询的开始时间
      currentUpdateTimeEnd: '',   // 当前查询的结束时间
      // ==================筛选===========================================

      // 项目列表表格分页参数
      currentProjectListPage: 1,
      currentProjectListPageSize: 50,
      // 项目列表卡片分页参数
      currentProjectCardsPage: 1,
      currentProjectCardsPageSize: 6,  // 卡片每页6个
columnFilterValues: {},
cardsRenderKey: 0,      

      // ✅ 项目异常详情弹窗（点击状态列红色圆点）
      exceptionDialogVisible: false,
      exceptionList: [],
      currentExceptionProjectNo: '',
      exceptionListColumn: [
        { prop: '项目编号', label: '项目编号' },
        { prop: '合同编号', label: '合同编号' },
        { prop: '任务号', label: '任务号' },
        { prop: '相关节点人', label: '相关节点人' },
        { prop: '异常类型', label: '异常类型' },
        { prop: '事件详情', label: '事件详情' },
        { prop: '发生时间', label: '发生时间' },
        { prop: '是否需要处理', label: '是否需要处理' },
        { prop: '处理人', label: '处理人' },
        { prop: '处理时间', label: '处理时间' },
        { prop: '解决时间', label: '解决时间' },
      ],
      //项目列表的表头
projectListColumn: [
  {
    prop: '数据状态码',
    label: '状态',
    width: 50,
    custom: true,
    column: {
      type: 'icon',
      icon: { default: 'status-circle' },
      tooltipField: '状态详情'
    }
  },
  {
    prop: '项目名称',
    label: '项目名称',
    filterable: true,
    custom: true,
    column: {
      type: 'link',
      field: '项目名称',
      eventName: 'projectLinkClick'
    }
  },
  {
    prop: '项目编号',
    label: '项目编号',
    filterable: true
  },
  {
    prop: '业务员',
    label: '业务员',
    filterable: true
  },
  {
    prop: '项目阶段',
    label: '项目阶段',
    filterable: true,
    filterType: 'select',
    filterOptions: PROJECT_STAGE_OPTIONS
  },
  {
    prop: '业务部门',
    label: '业务部门',
    filterable: true
  },
    {
    prop: '预计金额',
    label: '预计金额',
    filterable: true,
    filterPlaceholder: '不低于填入金额'
  },

  {
    prop: '产品大类',
    label: '产品大类',
    filterable: true
  },
  {
    prop: '录入时间',
    label: '录入时间',
    filterable: true,
    filterType: 'dateSelect'
  },
  {
    prop: '更新时间',
    label: '更新时间',
    filterable: true,
    filterType: 'date'   // ✅ 新增
  },
  {
    prop: '预计投标日期',
    label: '预计投标日期',
    filterable: true,
    filterType: 'date'   // ✅ 新增
  },

  {
    prop: '合同总金额',
    label: '合同总金额',
    filterable: true,
    filterPlaceholder: '不低于填入金额'
  },
  // {
  //   prop: '合同数量',
  //   label: '合同数量'
  // },
  // {
  //   prop: '审核合同数',
  //   label: '审核合同数'
  // },
  {
    prop: '审核/总合同数',
    label: '审核/总合同数',
    filterable: true,
    filterPlaceholder: '总合同数量'
    // width: 110,
    // align: 'center',
    // formatter: (row) => {
    //   const audit = row.审核合同数 || 0;
    //   const total = row.合同数量 || 0;
    //   return `${audit}/${total}`;
    // }
  }  

],
      // 手机端可用列 prop 过滤（供 mixin 保存/加载手机端列偏好）
      mobileColumnFilter: [
        '数据状态码',
        '项目名称',
        '项目阶段',
        '录入时间',
        '合同总金额',
        '合同数量',
        '审核/总合同数',
        
      ],
      // 手机端列编辑弹窗中可编辑的全部列（恢复默认时，mobileColumnFilter 中的列打钩，其余取消打钩）
      mobileColumnEditFilter: [
        '数据状态码',
        '项目名称',
        '项目编号',
        '业务员',
        '项目阶段',
        '业务部门',
        '预计金额',
        '产品大类',
        '录入时间',
        '更新时间',
        '预计投标日期',
        '合同总金额',
        '审核/总合同数',
      ]
 
      
    };
  },
  async mounted() {
    await this.loadColumnPref();
    this.$nextTick(() => {
      this.getProjectList();
      this.fetchCardData(this.statisticRange);
    });
  },
  methods: {
    // ------------A.主卡片方法------------------------
    async fetchCardData(range) {
      this.cardLoading = true;
      try {
        const now = new Date();
        const todayStr = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

        // 准备请求参数
        const params = {
          Paging_pageNumber: 1,
          Paging_pageSize: 10000,
          status: '',
          name: '',
          projectName: '',
          projectNo: '',
          startDate: this.getStartDate(range),
          currentDate: todayStr,
          endDate: '',
// ================新加的字段=========================
          "sortField":"field0014",
          "estimatedAmount":"",
          "contractNum":"",
          "contractAmount":"",
          "contractReviewNum":"",
          "productType":"",
          "updateStartDate":"",
          "updateEndDate":"",
          "biddingStartDate":"",
          "biddingEndDate":"",
          "department":""
        };
        
        // 调用接口 - 使用你的方式
        const response = await getSummaryData(params);
        
        // 处理响应
        if (response.data.code === 200) {
          this.updateCardData(response.data.data, range);
        } else {
          this.$message.error(`获取数据失败: ${response.message}`);
          this.setDefaultCardData();
        }
      } catch (error) {
        // this.$message.error('网络请求失败，请检查网络连接');
        this.setDefaultCardData();
      } finally {
        this.cardLoading = false;
      }
    },
    
    
    // 根据统计范围获取开始日期
    getStartDate(range) {
      const now = new Date();
      switch(range) {
        case 'year':
          return `${now.getFullYear()}-01-01`;
        case 'month':
          const month = (now.getMonth() + 1).toString().padStart(2, '0');
          return `${now.getFullYear()}-${month}-01`;
        default:  // 'month'
          const defaultMonth = (now.getMonth() + 1).toString().padStart(2, '0');
          return `${now.getFullYear()}-${defaultMonth}-01`;
      }
    },
    
    // 更新卡片数据
    updateCardData(apiData, range) {
      if (!apiData) {
        this.setDefaultCardData();
        return;
      }
      
      // 项目数据
      if (apiData.project) {
        this.cardData.project.value1 = apiData.project.bidTotalCount || 0;  // 已投标数
        this.cardData.project.value2 = apiData.project.projectTotalCount || 0;  // project总数
        this.cardData.project.tableData.bidding = [
          { 
            type: "投标中", 
            count: apiData.project.biddingCount || 0,  // 投标中数量
            ratio: (apiData.project.biddingCountRate || 0) + '%',  // 投标中比例
            amount: this.formatMoney(apiData.project.biddingAmount || 0),  // 投标中金额
            percentage: (apiData.project.biddingAmountRate || 0) + '%'  // 投标中金额比例
          },
          { 
            type: "中标", 
            count: apiData.project.winBidCount || 0,  // 中标数量
            ratio: (apiData.project.winBidCountRate || 0) + '%',  // 中标数量比例
            amount: this.formatMoney(apiData.project.winBidAmount || 0),  // 中标金额
            percentage: (apiData.project.winBidAmountRate || 0) + '%'  // 中标金额比例
          },
          { 
            type: "未中标", 
            count: apiData.project.loseBidCount || 0,  // 未中标数量
            ratio: (apiData.project.loseBidCountRate || 0) + '%',  // 未中标比例
            amount: this.formatMoney(apiData.project.loseBidAmount || 0),  // 未中标金额
            percentage: (apiData.project.loseBidAmountRate || 0) + '%'  // 未中标金额比例
          }
        ];
      }
      
      // 合同数据
      if (apiData.contract && apiData.contract.result) {
        this.cardData.contract.value1 = this.formatMoney(apiData.contract.result.未审核合同金额 || 0);
        this.cardData.contract.value2 = this.formatMoney(apiData.contract.result.累计金额 || 0);
        this.cardData.contract.unReviewCount = apiData.contract.result.未审核合同数 || 0;
      }

      // 执行数据
      if (apiData.execution) {
        this.cardData.execute.value1 = apiData.execution.有异常的有效合同数 || 0;
        this.cardData.execute.value2 = apiData.execution.有效合同总数 || 0;
      }
      
      // 发运数据
      if (apiData.delivery) {
        this.cardData.shipment.value1 = apiData.delivery.pendingDeliveryCount || 0;
        this.cardData.shipment.value2 = apiData.delivery.abnormalDeliveryCount || 0;
      }
      
      // 售后数据
      if (apiData.afterSales) {
        this.cardData.afterSales.value1 = parseInt(apiData.afterSales.unfinishedCount) || 0;
        this.cardData.afterSales.value2 = parseInt(apiData.afterSales.totalCount) || 0;
      }

      // 应收数据
      if (apiData.account) {
        const acc = apiData.account;
        if (range === 'month') {
          // 本月
          this.cardData.receivable.value1 = this.formatMoney(acc.totalInnerAccountMonth != null ? acc.totalInnerAccountMonth : 0);
          this.cardData.receivable.externalAccount = this.formatMoney(acc.outerAccountMonth != null ? acc.outerAccountMonth : 0);
          this.cardData.receivable.internalAccount = this.formatMoney(acc.innerAccountMonth != null ? acc.innerAccountMonth : 0);
        } else {
          // 本年（默认）
          this.cardData.receivable.value1 = this.formatMoney(acc.totalInnerAccountYear != null ? acc.totalInnerAccountYear : 0);
          this.cardData.receivable.externalAccount = this.formatMoney(acc.outerAccountYear != null ? acc.outerAccountYear : 0);
          this.cardData.receivable.internalAccount = this.formatMoney(acc.innerAccountYear != null ? acc.innerAccountYear : 0);
        }
      } else {
        this.cardData.receivable.value1 = 0;
        this.cardData.receivable.externalAccount = 0;
        this.cardData.receivable.internalAccount = 0;
      }
      
      // 注意：执行和应收数据后端暂时没有提供，保持默认值
      // this.cardData.execute.value1 = 0;
      // this.cardData.execute.value2 = 0;
      // this.cardData.receivable.value1 = 0;
      // this.cardData.receivable.externalAccount = 0;
      // this.cardData.receivable.internalAccount = 0;
      
      // 记录统计范围
      this.statisticRange = range;
    },
    
    // 格式化金额
    formatMoney(value) {
      if (typeof value !== 'number') {
        value = parseFloat(value) || 0;
      }
      if (value >= 10000) {
        return (value / 1).toFixed(2) + '万';
      }
      return value.toFixed(2);
    },
    
    // 设置默认卡片数据
    setDefaultCardData() {
      // 这里可以设置一些默认值
      this.cardData.project.value1 = 0;
      this.cardData.project.value2 = 0;
      this.cardData.contract.value1 = 0;
      this.cardData.contract.value2 = 0;
      this.cardData.shipment.value1 = 0;
      this.cardData.shipment.value2 = 0;
      this.cardData.afterSales.value1 = 0;
      this.cardData.afterSales.value2 = 0;
    },
    
    // 切换统计范围的方法
    handleStatisticRange(range) {
      this.statisticRange = range;
      this.fetchCardData(range);
    },
    // ------------A.主卡片方法------------------------



    // ------------B.项目列表卡片方法------------------------   
    // 新增：卡片分页处理
    handleCardsSizeChanges(val) {
      this.currentProjectCardsPageSize = val;
      this.currentProjectCardsPage = 1;  // 重置到第一页
      this.getProjectList();
    },
    
    handleCardsCurrentChanges(val) {
      this.currentProjectCardsPage = val;
      this.getProjectList();
    },

    // 卡片点击处理
    handleCardClick(card) {
      // 可以执行一些卡片特有的逻辑
      // 如果需要跳转，可以调用现有的 goToInfo 方法
      this.goToInfo(card);
    },    
    // ------------B.项目列表卡片方法------------------------

  // ✅ 列筛选变化处理
  onColumnFilterChange(filterValues) {
    this.columnFilterValues = filterValues;
    // 筛选条件变化时，重置两种视图的页码为 1，并强制重渲染分页组件
    this.currentProjectListPage = 1;
    this.currentProjectCardsPage = 1;
    this.tableRenderKey++;
    this.cardsRenderKey++;
    this.getProjectList();
  },

  // ✅ 卡片筛选框变化处理
  onCardFilterChange() {
    // 筛选条件变化时，重置两种视图的页码为 1，并强制重渲染分页组件
    this.currentProjectListPage = 1;
    this.currentProjectCardsPage = 1;
    this.tableRenderKey++;
    this.cardsRenderKey++;
    this.getProjectList();
  },

    /** 导出Excel */
    handleExport() {
      const xlsxParam = { raw: true };
      const wb = XLSX.utils.table_to_book(
        document.querySelector('#projectTable'),
        xlsxParam
      );
      const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          '项目列表.xlsx'
        );
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout);
        }
      }
      return wbout;
    },

    
    // 处理项目名称链接点击（特定事件）
    goToInfo(data) {
      const row = data.row || data;
      if (row && row.项目名称) {
        // 对项目名称进行URL编码，防止特殊字符问题
        const encodedNo = encodeURIComponent(row.项目名称);

        // 保存当前行数据到sessionStorage，以便在新页面使用
        window.sessionStorage.setItem('currentProjectData', JSON.stringify(row));
        this.$router.push({
          path: `/homepage/project/${encodeURIComponent(row.项目编号)}`,
          // query: {
          //   projectNo: encodeURIComponent(row.项目编号)
          // }
        });
        this.$EventBus.$emit('currentPath', '/homepage//project');
      } else {
        // console.warn('无法跳转：缺少项目编号');
      }
    },       
    

  handleViewToggle(val) {
    // console.log('视图切换为:', val ? '表格' : '图片');
    
    // 视图切换时重置到第一页
    if (val) {  // 切换到表格视图
      this.currentProjectListPage = 1;
      // 确保使用表格的页大小
      this.currentProjectListPageSize = 50;
    } else {  // 切换到卡片视图
      this.currentProjectCardsPage = 1;
      // 确保使用卡片的页大小
      this.currentProjectCardsPageSize = 6;
    }
    
    // 重新获取数据
    this.getProjectList();
  },
    handleProjectSizeChanges(val) {
      this.currentProjectListPageSize = val;
      this.getProjectList();
    },
    handleProjectCurrentChanges(val) {
      this.currentProjectListPage = val;
      this.getProjectList();
    },

     
    // 项目名称和项目编号查询
    async searchProjectList() {
      if (this.projectSearchTypeValue == '项目名称') {
        this.currentProjectKeyword = this.projectSearchKeyword;
        this.currentProjectNo = '';
      } else if (this.projectSearchTypeValue == '项目号') {
        this.currentProjectKeyword = '';
        this.currentProjectNo = this.projectSearchKeyword;
      }
      // else if (this.projectSearchTypeValue == '合同号') {
      //   this.currentProjectKeyword = '';
      //   this.currentProjectContractNo = this.projectSearchKeyword;
      // }

      this.getProjectList();
    },



handleTimeRangeTypeChange(type) {
  if (type === 'custom') {
    this.openCustomPicker();
  } else {
    this.showCustomPicker = false;
    this.setTimeRange(type);
  }
},

handleSelectVisibleChange(visible) {
  // 下拉框关闭时不处理
  if (!visible) return;

  // 当前已经是自定义 → 强制打开 picker
  if (this.timeRangeType === 'custom') {
    this.openCustomPicker();
  }
},


openCustomPicker() {
  this.timeRangeType = 'custom';
  this.showCustomPicker = true;

  this.$nextTick(() => {
    const picker = this.$refs.customDatePicker;
    const el = picker && picker.$el;
    const select = document.querySelector('.date-range-picker .el-input');

    if (!el || !select) return;

    const rect = select.getBoundingClientRect();

    el.style.position = 'fixed';
    el.style.top = rect.bottom + 6 + 'px';
    el.style.left = rect.left + 'px';
    el.style.zIndex = 3000;
    el.style.opacity = '1';
    el.style.pointerEvents = 'auto';
  });
},

setTimeRange(type) {
  const now = new Date();
  let start = null;
  let end = null;

  switch (type) {
    case 'year':
      start = new Date(now.getFullYear(), 0, 1);
      end = now;
      break;

    case 'month':
      start = new Date(now.getFullYear(), now.getMonth(), 1);
      end = now;
      break;

    case 'week':
      const day = now.getDay() || 7;
      start = new Date(now);
      start.setDate(now.getDate() - day + 1);
      end = new Date(start);
      end.setDate(start.getDate() + 6);
      break;

    case 'all':
    default:
      // ✅ 不传时间
      this.updateTimeRange = [];
      this.currentUpdateTimeStart = '';
      this.currentUpdateTimeEnd = '';
      this.getProjectList();
      return;
  }

  this.updateTimeRange = [
    this.formatDate(start),
    this.formatDate(end)
  ];

  this.changeUpdateTimeRange(this.updateTimeRange);
},

formatDate(dateStr) {
  if (!dateStr) return '';

  // ✅ 如果是字符串，先转成 Date
  let date;
  if (typeof dateStr === 'string') {
    // 兼容 "2026-06-29 16:43:21" 或 "2026-06-29"
    date = new Date(dateStr.replace(/-/g, '/'));
  } else if (dateStr instanceof Date) {
    date = dateStr;
  } else {
    return '';
  }

  if (isNaN(date.getTime())) return '';

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');

  return `${y}-${m}-${d}`;
},

  changeUpdateTimeRange(range) {
    if (range && range.length === 2) {
      this.currentUpdateTimeStart = range[0];
      this.currentUpdateTimeEnd = range[1];
    } else {
      this.currentUpdateTimeStart = '';
      this.currentUpdateTimeEnd = '';
    }
    this.getProjectList();
  },






    // // 更新时间范围变化查询
    // changeUpdateTimeRange(range) {
    //   if (range && range.length === 2) {
    //     this.currentUpdateTimeStart = range[0]; // 开始日期，如 '2024-06-01'
    //     this.currentUpdateTimeEnd = range[1];   // 结束日期，如 '2024-06-30'
    //   } else {
    //     // 清空选择时，重置查询参数
    //     this.currentUpdateTimeStart = '';
    //     this.currentUpdateTimeEnd = '';
    //   }
    //   this.getProjectList();
    // },

    // 项目状态查询
    changeProjectState(data) {
      this.currentProjectState = data;
      this.getProjectList();
    },

    // 修改：获取项目列表的请求参数，增加时间范围
  // ✅ 获取项目列表
  async getProjectList() {
    this.loading = true;

    const filter = this.columnFilterValues || {};
   // ✅ 核心修改：根据当前视图选分页参数
    const pageNumber = this.showTableView 
      ? this.currentProjectListPage 
      : this.currentProjectCardsPage;
    
    const pageSize = this.showTableView 
      ? this.currentProjectListPageSize 
      : this.currentProjectCardsPageSize;
    const params = {
      Paging_pageNumber: pageNumber,
      Paging_pageSize: pageSize,
      status: filter['项目阶段'] || '',
      name: filter['业务员'] || '',
      projectName: filter['项目名称'] || '',
      projectNo: filter['项目编号'] || '',
      startDate: this.currentUpdateTimeStart||(filter['录入时间'] ? filter['录入时间'][0] : ''),      // ✅ 录入时间开始
      endDate: this.currentUpdateTimeEnd||(filter['录入时间'] ? filter['录入时间'][1] : ''),        // ✅ 录入时间结束
      sortField: "field0014",
      estimatedAmount: filter['预计金额'] || '',
      contractNum: filter['审核/总合同数'] || '',
      contractAmount: filter['合同总金额'] || '',
      contractReviewNum: '',
      productType: filter['产品大类'] || '',
      updateStartDate: filter['更新时间'] ? filter['更新时间'][0] : '',      // ✅
      updateEndDate: filter['更新时间'] ? filter['更新时间'][1] : '',        // ✅
      biddingStartDate: filter['预计投标日期'] ? filter['预计投标日期'][0] : '', // ✅
      biddingEndDate: filter['预计投标日期'] ? filter['预计投标日期'][1] : '',   // ✅
      department: filter['业务部门'] || ''                                   // ✅
    };

      // 表格模式用 getProjectHomeList，卡片模式用 getProjectHomeList1
      const apiMethod = this.showTableView ? getProjectHomeList : getProjectHomeList1;
      const res = await apiMethod(params);
      this.loading = false;

      if (res.data.code === 200) {
        const data = res.data.data || {};
        this.projectData = data.projectList || data.list || [];
        this.projectTotal = +data.totalCount || 0;

        // 数据处理（保持你原有的逻辑）
        this.projectData.forEach((item, index) => {
          this.projectData[index].录入时间 = this.formatDate(item.录入时间);
          this.projectData[index].预计投标日期 = this.formatDate(item.预计投标日期);
          this.projectData[index].更新时间 = this.formatDate(item.更新时间);
          this.projectData[index].审核合同数 = item.已审核合同数量 || 0;
          this.projectData[index].合同数量 = item.合同数量 || 0;
          this.projectData[index].预计金额 = item.预计金额 || 0;
          this.projectData[index].合同总金额 = item.合同总金额 || 0;
          this.projectData[index].项目阶段 = item.项目阶段 || '';
          this.projectData[index].项目编号 = item.项目编号 || '';
          this.projectData[index].产品大类 = item.产品大类 || '';
          this.projectData[index].业务员 = item.业务员 || '';
          this.projectData[index].业务部门 = item.业务部门 || '';
          this.projectData[index].业主单位 = item.业主单位 || 'NANA';
          // ✅ 新增：直接拼好要显示的字符串，哪怕是0/0也会保留
          this.projectData[index]['审核/总合同数'] = `${item.已审核合同数量 || 0}/${item.合同数量 || 0}`;
          // ✅ 后端新增字段：是否有异常（true → 状态圆点强制红色）
          this.projectData[index].hasException = item.hasException === true || item.hasException === 'true';
          this.projectData[index].exceptionCount = Number(item.exceptionCount || 0);
        });

        // ✅ 数据整理完再统一算状态色（原来写在 forEach 里，会重复算 N 遍）
        this.mapProjectStatus();
      } else {
        this.$message.error('获取项目列表失败');
    } 
  },

      // ✅ 状态圆点颜色：hasException 优先 → 其次按“项目阶段”
  mapProjectStatus() {
    if (!this.projectData || !Array.isArray(this.projectData)) {
      return;
    }

    this.projectData.forEach(item => {
      const stage = item.项目阶段 || '';

      // ① 异常优先级最高：只要 hasException 为 true 就是红色
      if (item.hasException === true || item.hasException === 'true') {
        item.数据状态码 = STATUS_CODE_EXCEPTION; // 红色
        const count = Number(item.exceptionCount || 0);
        item['状态详情'] = stage
          ? `${stage}（存在异常，可点击查看异常详情）`
          : `存在异常，可点击查看异常`;
        return;
      }

      // ② 无异常时按项目阶段取色：投标准备/信息收集/跟进/线索收集/其他=灰，投标中=蓝，中标=绿，中止/未中标=橙
      item.数据状态码 = STAGE_STATUS_CODE[stage] !== undefined
        ? STAGE_STATUS_CODE[stage]
        : STATUS_CODE_DEFAULT;

      // 悬浮提示显示项目阶段文字
      item['状态详情'] = stage;
    });
  },

  /** ✅ 状态图标点击 - 仅异常行（红色圆点）弹出异常详情
   *  与 workOrderProgress 一致，区别：传给后端的从 taskNo 换成 projectNo */
  async handleStatusIconClick({ row }) {
    // 仅当数据状态码为 0（异常：hasException = true）时响应
    if (row['数据状态码'] !== 0 && row['数据状态码'] !== '0') {
      return;
    }
    const projectNo = row['项目编号'];
    if (!projectNo) {
      this.$message.warning('该行没有项目编号');
      return;
    }

    this.currentExceptionProjectNo = projectNo;

    try {
      const res = await getAbnormalInfo({
        taskNo: '',
        contractNo: '',
        projectNo: projectNo
      });

      if (res.data.code === 200 && res.data.data && res.data.data.exceptionInfo) {
        const rawList = res.data.data.exceptionInfo;
        this.exceptionList = rawList.map(item => ({
          '项目编号': item['项目编号'] || '',
          '合同编号': item['合同编号'] || '',
          '任务号': item['任务号'] || '',
          '相关节点人': item['相关节点人'] || '',
          '异常类型': item['异常类型'] || '',
          '事件详情': item['事件详情'] || '',
          '发生时间': item['发生时间'] || '',
          '是否需要处理': item['是否需要处理'] || '',
          '处理人': item['处理人'] || '',
          '处理时间': item['处理时间'] || '',
          '解决时间': item['解决时间'] || '',
        }));
        this.exceptionDialogVisible = true;
      } else {
        this.$message.info('该项目暂无异常详情');
      }
    } catch (error) {
      this.$message.error('查询异常详情失败');
    }
  },

  /** 关闭异常详情弹窗 */
  closeExceptionDialog() {
    this.exceptionDialogVisible = false;
    this.exceptionList = [];
    this.currentExceptionProjectNo = '';
  }
 
  }
};
</script>



<style scoped lang="scss">

.project {
  display: flex;
  flex-wrap: wrap;
  min-width: 300px;
  position: relative;
  width: 100%;
  // height: calc(100vh); /* 减去标题栏和间距的高度 */
  height: calc(100vh - 65px); /* 减去标题栏和间距的高度 */
  // min-height: 900px;

  flex-direction: column;
}

// 新增：日期范围选择器样式微调
.date-range-picker {
  // 可根据需要调整样式，比如宽度
  width: 20%; 
}
.selection {
  min-width: 100px;
  width: 20%;
  margin-right: 8px; // 添加少许间距
}
.search-box {
  width: 20%;
  min-width: 200px;
  margin-right: 8px; // 添加少许间距
}
.dateRange {
  width: 20%;
  height: 25%;
  display: flex;
  justify-content: space-evenly;
  span {
    cursor: pointer;
    display: flex;
    font-size: 0.875rem;
    width: 69px;
    height: 40px;
    align-items: center;
    justify-content: center;
    color: rgb(128, 128, 128);
    font-family: Noto Sans SC;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -1px;
    text-align: left;
    &:hover {
      color: rgba(38, 120, 255, 0.9);
      border-bottom: 3px solid rgba(38, 120, 255, 0.9);
    }
  }

  .active {
    color: rgba(38, 120, 255, 0.9);
    border-bottom: 3px solid rgba(38, 120, 255, 0.9);
  }
}
.echartsmain {
  width: 100%;
  height: 100%;
}

/* 在现有样式后添加 */
.filter-content {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.filter-item {
  // min-width: 150px;
  flex: 1;
}

.view-toggle {
  flex: none;
  margin-left: auto;
}

.statistic-range-selector {
  display: flex;
  align-items: center;
  .selector-label {
    font-size: 14px;
    color: #606266;
    margin-right: 8px;
    white-space: nowrap;
  }
  .el-select {
    width: 120px;
  }
}

::v-deep .card-m {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

::v-deep .card-box {
  flex: 1;
  min-height: 0;   /* ⭐ 非常关键 */
  overflow-y: hidden;  /* 始终显示垂直滚动条轨道，避免闪烁 */
  overflow-x: hidden;
}

/* ✅ 确保 picker 永远在最上层 */
::v-deep .custom-date-popper {
  z-index: 3000 !important;
}

</style>


<style>
/* ✅ 手机端：整个双月日期选择器整体缩小 */
@media (max-width: 768px) {
  .date-range-small.el-date-range-picker {
    width: 520px !important;
    transform: scale(0.72);
    transform-origin: top center;   /* ✅ 关键 */
    left: 50% !important;
    margin-left: -260px !important; /* 520 * 0.82 / 2 ≈ 213，保守点写 */
  }

  /* 输入框也同步缩小 */
  .date-range-small .el-input__inner {
    height: 26px !important;
    line-height: 26px !important;
    font-size: 11px !important;
  }

  .date-range-small .el-input__icon {
    line-height: 26px !important;
    font-size: 20px !important;
  }

  .filter-content {
    flex-wrap: wrap;
  }

  .filter-item {
    flex: 1 1 1 33% !important; /* 一行两个 */
    min-width: 90px;
  }


}
</style>